import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesStock from "Dashboard/scenes/Stock/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import {
  selectInputForUpdateItem,
  selectState,
  setUpdateInputItemPopover,
  updateInput
} from "../input.slice";
import { IConsumablesInputUpdate } from "Dashboard/scenes/Consumables/domain/IConsumablesInputUpdate";
import NumberInput from "Dashboard/components/NumberInput";

const UpdateConsumablesInputItemPopover = () => {
  const dispatch = useAppDispatch();
  const input = useSelector(selectInputForUpdateItem);
  const { updateInputItemPopover } = useSelector(selectState);
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
  } = useForm<IConsumablesInputUpdate>();

  const closeDialog = () => {
    dispatch(setUpdateInputItemPopover({ isOpen: false, itemRowIndex: -1 }));
    reset();
  };

  const onSubmit = async (data: IConsumablesInputUpdate) => {
    try {
      await dispatch(updateInput(data));
      closeDialog();
      toast.success("Izmena je uspešno zabeležena.");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`
        ${classes.basicPopoverView} 
        ${classes.gPopoverInputs}
        ${classesStock.updateInputItemPopover}
      `}
    >
      <p>Ovde menjate šifru, ime i cenu artikla na ulazu kao i na svim zapisima izlaza ovog artikla.</p>
      <input
        type="hidden"
        value={input?.inputId}
        {...register("inputId")}
      />

      <div className={`${errors.itemCode ? classes.inputError : ""}`}>
        <div>
          <label>nova šifra</label>
          <input
            type="text" className={classes.solidBorder}
            autoFocus={updateInputItemPopover.focus === "itemCode"}
            defaultValue={input !== null ? input.item.latestItemCode : ""}
            {...register("itemCode", { required: false })} />
        </div>
      </div>
      <div className={`${errors.itemName ? classes.inputError : ""}`}>
        <div>
          <label>ime</label>
          <input
            type="text" className={classes.solidBorder}
            disabled
            defaultValue={input !== null ? input.item.name : ""} />
        </div>
      </div>
      <div>
        <div>
          <label>nova cena</label>
          <Controller
            control={control}
            name="pricePerUnit"
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <NumberInput
                  formatAs="rsd"
                  autoFocus={updateInputItemPopover.focus === "pricePerUnit"}
                  onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                  defaultValue={input?.pricePerUnit !== null && input?.pricePerUnit !== undefined ? input.pricePerUnit.toString().replace(".", ",") : ""}
                  className={`${classes.solidBorder} ${errors.pricePerUnit ? classes.itemError : ""}`}
                />
              </div>
            )}
          />

        </div>
      </div>

      <div className={classes.buttons}>
        <button type="submit" className={classes.iconButton}>
          <FontAwesomeIcon
            icon={faLongArrowAltDown}
            className={classes.icon} />
        </button>
      </div>
    </form>
  )
};

export default UpdateConsumablesInputItemPopover;
